import styled from "@emotion/styled";

const Description = styled.div`
  color: rgba(198, 201, 216, 0.75);
  font-size: 18px;
  line-height: 1.67;
`;

export default Description;
